import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgEmailinline = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 64 64",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		fill: "none",
		fillRule: "evenodd",
		strokeLinejoin: "round",
		stroke: "currentColor",
		strokeWidth: 2,
		children: [/* @__PURE__ */ _jsx("rect", {
			strokeLinecap: "square",
			x: 4,
			y: 14,
			width: 56,
			height: 36,
			rx: 4
		}), /* @__PURE__ */ _jsx("path", { d: "M59.5 15.5L32 37 4.5 15.5m32.7 17.495L58.5 48.5 37.2 32.995zM27 33L5 49" })]
	})
});
export default SvgEmailinline;
